// store/thunks/appSettingsThunks.js
import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import appSettingsService from "../../services/appSettingsService";

// ===== APP CONFIG THUNKS =====
export const createAppConfigThunk = createAsyncThunk(
  "appSettings/createConfig",
  async (configData, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.createAppConfig(configData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateAppConfigThunk = createAsyncThunk(
  "appSettings/updateConfig",
  async ({ id, configData }, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.updateAppConfig(id, configData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchAllConfigsThunk = createAsyncThunk(
  "appSettings/fetchAllConfigs",
  async (filterParams, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.getAllConfigs(filterParams);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchConfigByIdThunk = createAsyncThunk(
  "appSettings/fetchConfigById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.getConfigById(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const deleteConfigThunk = createAsyncThunk(
  "appSettings/deleteConfig",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.deleteConfig(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const activateConfigThunk = createAsyncThunk(
  "appSettings/activateConfig",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.activateConfig(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const cloneConfigThunk = createAsyncThunk(
  "appSettings/cloneConfig",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.cloneConfig(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== BANNER THUNKS =====
export const createBannerThunk = createAsyncThunk(
  "appSettings/createBanner",
  async (bannerData, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.createBanner(bannerData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateBannerThunk = createAsyncThunk(
  "appSettings/updateBanner",
  async ({ id, bannerData }, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.updateBanner(id, bannerData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchAllBannersThunk = createAsyncThunk(
  "appSettings/fetchAllBanners",
  async (filterParams, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.getAllBanners(filterParams);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchBannerByIdThunk = createAsyncThunk(
  "appSettings/fetchBannerById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.getBannerById(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const deleteBannerThunk = createAsyncThunk(
  "appSettings/deleteBanner",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.deleteBanner(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateBannerStatusThunk = createAsyncThunk(
  "appSettings/updateBannerStatus",
  async ({ id, statusData }, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.updateBannerStatus(
        id,
        statusData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const reorderBannersThunk = createAsyncThunk(
  "appSettings/reorderBanners",
  async (orderData, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.reorderBanners(orderData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchBannerAnalyticsThunk = createAsyncThunk(
  "appSettings/fetchBannerAnalytics",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.getBannerAnalytics(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== COLLECTION THUNKS =====
export const createCollectionThunk = createAsyncThunk(
  "appSettings/createCollection",
  async (collectionData, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.createCollection(
        collectionData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateCollectionThunk = createAsyncThunk(
  "appSettings/updateCollection",
  async ({ id, collectionData }, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.updateCollection(
        id,
        collectionData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchAllCollectionsThunk = createAsyncThunk(
  "appSettings/fetchAllCollections",
  async (filterParams, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.getAllCollections(filterParams);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchCollectionByIdThunk = createAsyncThunk(
  "appSettings/fetchCollectionById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.getCollectionById(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const deleteCollectionThunk = createAsyncThunk(
  "appSettings/deleteCollection",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.deleteCollection(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateCollectionStatusThunk = createAsyncThunk(
  "appSettings/updateCollectionStatus",
  async ({ id, statusData }, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.updateCollectionStatus(
        id,
        statusData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchCollectionProductsThunk = createAsyncThunk(
  "appSettings/fetchCollectionProducts",
  async ({ id, filterParams }, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.getCollectionProducts(
        id,
        filterParams
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== CONTACT INFO THUNKS =====
export const createContactInfoThunk = createAsyncThunk(
  "appSettings/createContactInfo",
  async (contactData, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.createContactInfo(contactData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateContactInfoThunk = createAsyncThunk(
  "appSettings/updateContactInfo",
  async ({ id, contactData }, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.updateContactInfo(
        id,
        contactData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchAllContactInfoThunk = createAsyncThunk(
  "appSettings/fetchAllContactInfo",
  async (filterParams, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.getAllContactInfo(filterParams);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchContactInfoByIdThunk = createAsyncThunk(
  "appSettings/fetchContactInfoById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.getContactInfoById(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const deleteContactInfoThunk = createAsyncThunk(
  "appSettings/deleteContactInfo",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.deleteContactInfo(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== FEATURE FLAGS THUNKS =====
export const updateFeatureFlagsThunk = createAsyncThunk(
  "appSettings/updateFeatureFlags",
  async ({ configId, featureData }, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.updateFeatureFlags(
        configId,
        featureData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const bulkUpdateFeaturesThunk = createAsyncThunk(
  "appSettings/bulkUpdateFeatures",
  async (featuresData, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.bulkUpdateFeatures(
        featuresData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== HOME LAYOUT THUNKS =====
export const updateHomeLayoutThunk = createAsyncThunk(
  "appSettings/updateHomeLayout",
  async ({ configId, layoutData }, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.updateHomeLayout(
        configId,
        layoutData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const previewHomeLayoutThunk = createAsyncThunk(
  "appSettings/previewHomeLayout",
  async (layoutData, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.previewHomeLayout(layoutData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== IMPORT/EXPORT THUNKS =====
export const importBannersThunk = createAsyncThunk(
  "appSettings/importBanners",
  async (file, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.importBanners(file);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const exportConfigThunk = createAsyncThunk(
  "appSettings/exportConfig",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.exportConfig(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== EXPERIMENT THUNKS =====
export const createExperimentThunk = createAsyncThunk(
  "appSettings/createExperiment",
  async (experimentData, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.createExperiment(
        experimentData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateExperimentThunk = createAsyncThunk(
  "appSettings/updateExperiment",
  async ({ id, experimentData }, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.updateExperiment(
        id,
        experimentData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchExperimentsThunk = createAsyncThunk(
  "appSettings/fetchExperiments",
  async (filterParams, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.getExperiments(filterParams);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchExperimentResultsThunk = createAsyncThunk(
  "appSettings/fetchExperimentResults",
  async (id, { rejectWithValue }) => {
    try {
      const response = await appSettingsService.getExperimentResults(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== ACTIONS =====
export const clearAppSettingsError = createAction("appSettings/clearError");
export const resetSelectedConfig = createAction(
  "appSettings/resetSelectedConfig"
);
export const resetSelectedBanner = createAction(
  "appSettings/resetSelectedBanner"
);
export const resetSelectedCollection = createAction(
  "appSettings/resetSelectedCollection"
);
export const setAppSettingsFilter = createAction("appSettings/setFilter");
